import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { EmptyStateIcon } from './emptyStateIcon';
import { EmptyStateContainerBlock } from './style';
import { st, classes } from './emptyState.st.css';
import wixService from '../../../services/wixService';

const EmptyState = (props) => {
  const emptyStateRef = React.useRef();

  useEffect(() => {
    const resize = () => {
      setTimeout(() => {
        const height = emptyStateRef?.current?.clientHeight
          ? emptyStateRef.current.clientHeight
          : null;
        if (height) {
          wixService.setHeight(height);
        }
      }, 500);
    };

    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [emptyStateRef]);
  const { t, styleParams, design, settings, isSiteMode } = props;

  const messagesTitleKeys = [
    t('faq.err.state.title'),
    t('faq.isNoCategorySelected.state.title'),
    t('faq.empty.state.title'),
  ];
  const messagesDescriptionKeys = [
    t('faq.err.state.description'),
    t('faq.isNoCategorySelected.state.description'),
    t('faq.empty.state.description'),
  ];
  const messageType = settings.isError
    ? 0
    : settings.isNoCategorySelectedMessage
    ? 1
    : settings.isNoFAQs
    ? 2
    : 2;

  return (
    <EmptyStateContainerBlock
      styleParams={styleParams}
      design={design}
      settings={settings}
    >
      <div ref={emptyStateRef} className={classes.emptyStateWrapper}>
        <EmptyStateIcon />
        <div className={classes.title}>{messagesTitleKeys[messageType]}</div>
        {isSiteMode && settings.isNoFAQs ? null : (
          <div className={classes.description}>
            {messagesDescriptionKeys[messageType]}
          </div>
        )}{' '}
      </div>
    </EmptyStateContainerBlock>
  );
};

export default withTranslation()(EmptyState);
